import React, { useEffect } from 'react'
import { useMutation } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom'
import packageService from '../../../../../service/reactQueryServices/services/packageService';
import CustomValuesHookTS from '../../../../../Hooks/CustomValuesHookTS';
import { useTranslation } from 'react-i18next';
import MessageModal from '../../../../../components/Message';
import { unsuccessPayment, successPayment } from "../../../../../components/images"

const PayBack = () => {
    const { mutateAsync: getInvoiceDetail, isLoading: getInvoiceDetailPendeng } = useMutation("getInvoiceDetail", packageService.getInvoiceDetail);
    const [localStates, setLocalStates] = CustomValuesHookTS<any>({})
    const { t } = useTranslation()
    const navigate = useNavigate()

    const params = useParams()
    useEffect(() => {
        if (params.invoiceId) {
            handleGetInvoice()

        }
    }, [])

    const handleGetInvoice = async () => {
        try {
            const response = await getInvoiceDetail(params.invoiceId)
            if (response.status === 200) {
                setLocalStates({ invoiceDetail: response.data })
            }
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <div className='mt-3' >
            <div className='pay-back-container'>
                <div className='mt-2 mb-2'>
                    {localStates.invoiceDetail?.extraInfo?.status === "Paid" ? <>
                        <div className='general-page-title' >{t("TITLES.CONGRATULATIONS")}</div>

                        <p>{t("DESCRIPTIONS.CONGRATULATIONS1")}</p>
                    </> : <>
                        <div className='general-page-title' >{""}</div>

                        <p>{""}</p></>}


                </div>

                <div>

                    {localStates.invoiceDetail &&
                        <div>
                            {localStates.invoiceDetail?.extraInfo?.status !== "Paid" ?
                                <div className='pay-result'><img src={unsuccessPayment} alt="message" />
                                    <p>{t("TOAST.ERROR_PAYMENT")}</p>
                                    <button className='btn btn-primary' onClick={() => { }} ></button>
                                </div> :
                                <div className='pay-result'><img src={successPayment} alt="message" />
                                    <p>{t("TOAST.SUCCESS_PAYMENT")}</p>
                                </div>}
                            <div className='d-flex justify-content-end' >
                                <button className='btn btn-primary' onClick={() => window.location.href = "/"} >{t("ACTIONS.PORTAL_ENTERING")}</button>

                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>

    )
}

export default PayBack